import {
    NotificationTargets,
    NotificationTemplateForAdmin,
    NotificationTypes,
    UpdateNotificationType,
} from '@sapphicsavvy/business';

export function extractNormalizedTemplateFields(
    templateHash: Record<NotificationTypes, NotificationTemplateForAdmin>,
): UpdateNotificationType[] {
    if (!templateHash || Object.keys(templateHash).length === 0) {
        return [];
    }

    return Object.values(templateHash).map((template) => {
        const normalizedTemplate: UpdateNotificationType = {
            type: template.type,
            isActive: template.isActive,
            customMessage:
                typeof template.customMessage === 'string'
                    ? template.customMessage.trim()
                    : undefined,
            customTitle:
                typeof template.customTitle === 'string'
                    ? template.customTitle.trim()
                    : undefined,
            ...(template.target !== NotificationTargets.all
                ? { target: template.target }
                : {}),
            ...(template.sendAtDate !== undefined && {
                sendAtDate: template.sendAtDate,
            }),
            ...(template.sendAtTime !== undefined && {
                sendAtTime: template.sendAtTime,
            }),
        };

        return normalizedTemplate;
    });
}
